import React from 'react';
import Body from '../components/Transactions/Body';

const TransactionsPage = () => {
	return <Body />;
};

export default TransactionsPage;
